export default "__VITE_ASSET__B0Hm3wWP__"